import React, {useState} from 'react'
import {useAuth} from "../../../providers/AuthProvider";
import SupplierFormItemProvider from "../providers/SupplierFormItemProvider";
import SupplierKeyClientsForm from "./SupplierKeyClientsForm";
import ProfileKeyClientRow from "../../profiles/components/ProfileKeyClientRow";

const SupplierKeyClientsStep = ({supplierOrg, onChange, onSave,...props}) => {

    const {auth} = useAuth()
    const [editingIndex, setEditingIndex] = useState(false);

    const addNewArrayProp = async (propName) => {

        let models = TB.get({...supplierOrg}, propName, []);
        models.push({});

        await onChange({[propName]: models});
        return setEditingIndex(models?.length - 1)
    }
    const getModelFromProps = (client) => {

        let {
            industries = [], skills = [], disciplines = [], assets, docAssets = [], imgAssets, ...model
        } = {...(client || {})}

        imgAssets = TB.map(imgAssets || [], asset => {
            if (asset.id) {
                return {
                    ...asset,
                    thumbUrl: asset.path,
                    url: asset.path,
                }
            }
            return asset
        })
        industries = TB.map(industries, item => ({...item, type: 'industries', value: `industry-${parseInt(item.id)}`}))
        skills = TB.map(skills, item => ({...item, type: 'skills', value: `skill-${parseInt(item.id)}`}))
        disciplines = TB.map(disciplines, item => ({
            ...item,
            type: 'disciplines',
            value: `discipline-${parseInt(item.id)}`
        }))


        return {...(client || {}), imgAssets, industries, skills, disciplines}
    }

    return (
        <div>
            <div className="form-title-section">
                <div className="step-title-content">
                    <div>
                        <div className="flex items-center pb-4">
                            <h3 className="form-title !mb-0">
                                Work Samples
                            </h3>

                            {/*{this.constructor.LastUpdatedMethod && this.renderLastUpdated(this.constructor.LastUpdatedMethod)}*/}
                        </div>

                        <h5 className="form-subtitle">
                            Show clients what you’re capable of. Below, upload documents that highlight your best work.
                        </h5>
                    </div>
                </div>
            </div>

            {TB.map(supplierOrg?.key_clients || [], (clientItem, clientIndex) => {

                const client = getModelFromProps(clientItem);
                return (
                    <SupplierFormItemProvider
                        key={`key_clients-${client.id}-${clientIndex}`}
                        itemIndex={clientIndex}
                        preview={<div className="px-4">
                            <ProfileKeyClientRow project={client}/>
                        </div>}
                        onChange={clientProps => {
                            let changedModel = TB.cloneDeep(client);
                            for (let [key, value] of Object.entries(clientProps)) {
                                changedModel = TB.set(changedModel, key, value);
                            }

                            if (!client?.brand && clientProps.brand) {
                                changedModel.headline = clientProps.brand.name;
                                changedModel.logo_path = clientProps.brand.icon;
                            }

                            if (changedModel.imgAssets?.length || changedModel.docAssets?.length) {
                                changedModel.assets = TB.concat(TB.cloneDeep(changedModel.imgAssets), TB.cloneDeep(changedModel.docAssets));
                            } else changedModel.assets = []

                            return changedModel
                        }}
                        onSave={async (keyClientProps) => {
                            console.log('keyClientProps', keyClientProps);

                            const formatPropsForRequest = client => {
                                let tagTypes = ['disciplines', 'skills', 'industries']
                                let formatted = TB.pick(client, [
                                    'id',
                                    ...tagTypes,
                                    'brands',
                                    'assets',
                                    'links',
                                    'headline',
                                    'year',
                                    'image_path',
                                    'description',
                                    'display_index',
                                ]);
                                TB.map(tagTypes, type => {
                                    formatted[type] = TB.map(formatted[type] || [], item => TB.pick(item, ['id']))
                                })
                                formatted.brands = TB.map(formatted.brands || [], item => TB.pick(item, ['id', 'domain', 'name','icon','is_custom']))
                                formatted.assets = TB.map(formatted.assets || [], (item, index) => {

                                    return TB.pick(item, ['id', 'content_type', 'path','caption','display_index'])
                                })

                                return formatted
                            }
                            if (!keyClientProps) {
                                let clients = TB.filter([...supplierOrg?.key_clients], (keyClients, keyClientIndex) => {
                                    return clientIndex !== keyClientIndex;
                                });
                                if (client?.id) {
                                    clients = TB.map(clients, client => formatPropsForRequest(client))
                                    return onSave({key_clients: clients}, true);
                                }
                                await onChange({key_clients: clients})
                            }else {
                                let clients = TB.set([...supplierOrg?.key_clients], clientIndex, keyClientProps);
                                await onChange({key_clients: clients});
                                await setEditingIndex(false);
                                clients = TB.map(clients, client => formatPropsForRequest(client))

                                return onSave({key_clients: clients}, true);
                            }
                        }}
                        model={client}
                        isUpdating={false}
                        isEditing={editingIndex === clientIndex}
                        onEditing={(toggle) => {
                            setEditingIndex(toggle ? clientIndex : false)
                        }}
                        displayName="Client Work Example"
                        itemPropName="key_clients">

                        <SupplierKeyClientsForm />

                    </SupplierFormItemProvider>
                )
            })}

            <div
                className={'white-panel talent-role-panel ' + (!!editingIndex && 'no-edit')}>
                <button
                    disabled={false}
                    className="btn btn-outline-dark" onClick={() => addNewArrayProp('key_clients')}>

                    Add Client Work Example #{supplierOrg?.key_clients?.length + 1} <i className="ml-1 fa fa-plus"/>
                </button>
            </div>
        </div>
    )
}
export default SupplierKeyClientsStep

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};